export default {
  api: {
    error: {
      currency: {
        notFound: "Valuta niet gevonden",
      }
    }
  }
}
